import { noTechnicalKnowledgeRequired } from './no-technical-knowledge-required';
import { connectMultipleSources } from './connect-multiple-sources';
import { onTopicResponses } from './on-topic-responses';
import { shareWithEmployees } from './share-with-employees';
import { exportIntegrations } from './export-integrations';
import type { FeaturePageDataInterface } from './types';

export type { FeaturePageDataInterface } from './types';

// Order drives the header dropdown, footer column, and homepage grid.
export const featurePages: FeaturePageDataInterface[] = [
  noTechnicalKnowledgeRequired,
  connectMultipleSources,
  onTopicResponses,
  shareWithEmployees,
  exportIntegrations,
];
